const list = ['KV27','LE76','LE95','LK66','MI33','ML74',];
const gifList = []; 
const ajax_url = 'https://tool.m3guo.com/api/web/m3goods/eq-item/';
const img_src = 'https://web-resource.17m3.com/m3guo/202309/team/tips/';
const img_file = '.png';

export default{
    list,
    gifList,
    ajax_url,
    img_src,
    img_file,
}


// WEBPACK FOOTER //
// ./src/directives/config/tipsConfig.js